import React from 'react';
import '../App.css';
import './HeaderSection.css';
import { Spacer } from './Spacer';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

function HeaderSection() {
  return (
    <Swiper
      modules={[Autoplay]}
      spaceBetween={0}
      slidesPerView={1}
      autoplay={{ delay: 5000 }}
      loop={true}
      allowTouchMove={true}
    >
      <SwiperSlide>
        <div className='Header-container'>
          <div className='text-box'>
            <h1>Get RM10</h1>
            <p className='left'>When you spend RM200!</p>
            <div className='Header-btns left'>
              <Spacer axis='vertical' size={8} />
              <a
                className='btns btn--outline btn--small'
                style={{ textDecoration: 'none' }}
                href='https://www.causewaylink.com.my/others-information/loyalty-program/'
              >
                Learn More
              </a>
            </div>
          </div>
        </div>
      </SwiperSlide>
      {/* <SwiperSlide>
				<div
					onClick={() =>
						window.open(
							'https://www.causewaylink.com.my/causeway-link-express-free-shuttle-bus-service',
							'_blank'
						)
					}
					className='Header-container shuttle-bus'
				></div>
			</SwiperSlide> */}
    </Swiper>
  );
}

export default HeaderSection;
